export const CHECKED_CLASS = 'checked';
export const REQUIRED_CLASS = 'required';
